import React from 'react';
import { TypedMemo } from '../../../../common/types';
import { SongPageSection, songPageSectionId } from './catalogSongPath';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from './SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongPageSectionBlockProps {
  section: SongPageSection;
  title: string;
  /** Shows at the right of the title, for example the Times / Text switch of the Lyrics section. */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * One section of the song page. The design had four tabs; the owner chose one long page
 * (2026-10-06), so each tab is a section here, and `?tab=` scrolls to it.
 */
const SongPageSectionBlockComponent: React.FC<SongPageSectionBlockProps> = ({ section, title, aside, children }) => {
  const id = songPageSectionId(section);
  return (
    <section id={id} className={styles.section} aria-labelledby={`${id}-title`} data-testid={id}>
      <div className={styles.sectionHead}>
        <h2 id={`${id}-title`} className={styles.sectionTitle}>
          {title}
        </h2>
        {aside}
      </div>
      {children}
    </section>
  );
};

export const SongPageSectionBlock = TypedMemo(SongPageSectionBlockComponent);
